// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a48530b1","879":"fb906401"}[chunkId] + ".chunk.js";
};